import React, { Component, useEffect, useRef } from "react";
import { Wrapper } from "@googlemaps/react-wrapper";
import Geocode from "react-geocode";

export class Confirm extends Component {

    componentDidMount() {
        window.scrollTo(0, 0)

        //VWO
        try {               
    
            if (typeof window.VWO !== "undefined") {
            
                window.VWO = window.VWO || [];
                window.VWO.event = window.VWO.event || function () 
                {
                    window.VWO.push(["event"].concat([].slice.call(arguments))
                )};

                window.VWO.event("onlineBookingFormTyp");

                console.log("VWO Tracking event loaded - Online booking");

            }

        } catch (err) {
            console.log("Error Logging VWO Tracking Event for - Online booking");
        }
    }

    render() {
        const { values } = this.props;
        let errorMessage = values.errorMsg;
        
        return (
            <>


                <div className="ob-confirm ob-background" style={{ backgroundImage: "url(" + document.getElementById("FinalPageTitleBackgroundImage").value + ")" }}>
                    <div className="ob-confirm__container">
                        <h1 className="ob-confirm__heading">
                            {document.getElementById("FinalPageTitle").value}
                        </h1>
                        {
                            (errorMessage === "") ?
                                <h2 className="ob-confirm__subheading">
                                    You will receive a confirmation email at "{values.contactEmail}"
                                    momentarily.
                                </h2>
                                :
                                <h2 className="ob-confirm__subheading">
                                    {errorMessage}, please contact us at{" "}
                                    <a className="ob-confirm__link2" href="tel:833-591-0365">
                                        +1 (833) 591-0365
                                    </a>
                                </h2>
                        }

                    </div>
                </div>
                <div className="ob-confirm__details">
                    <div className="ob-confirm__wrapper">
                        <div className="ob-confirm__half">
                            <h2 className="ob-confirm__h2">Appointment details</h2>
                            <p className="ob-confirm__paragraph">
                                A local agent will be in touch within 24 hours to confirm your
                                requested appointment.
                            </p>
                            <ul className="ob-confirm__details-list">
                                <li className="ob-confirm__details-item">
                                    <span className="details-item--bold">Date: </span>
                                    {values.appointmentDateString}
                                </li>
                                <li className="ob-confirm__details-item">
                                    <span className="details-item--bold">Time: </span>
                                    {values.appointmentTimeString}
                                </li>
                                <li className="ob-confirm__details-item">
                                    <span className="details-item--bold">
                                        Phone :&nbsp;
                                        <a
                                            className="ob-confirm__link"
                                            href={`tel:${values.appointmentPhone}`}
                                        >
                                            {values.contactPhone}
                                        </a>
                                    </span>
                                </li>
                                <li className="ob-confirm__details-item">
                                    <span className="details-item--bold">
                                        Location :&nbsp;
                                        <a
                                            className="ob-confirm__link"
                                            href={`${values.appointmentLocation}`}
                                        >
                                            {values.movingFromStreet}
                                        </a>
                                    </span>
                                </li>
                            </ul>
                            <p className="ob-confirm__paragraph">
                                If you have any questions and would like to speak to a rep,
                                please contact us at{" "}
                                <a className="ob-confirm__link" href="tel:833-591-0365">
                                    +1 (833) 591-0365
                                </a>
                            </p>
                        </div>
                        <div className="ob-confirm__half">
                            <img src={document.getElementById('FinalPageAppointmentDetailImage').value} alt="Truck" />
                        </div>
                    </div>
                </div>
                <div className="ob-confirm__checklist">
                    <div className="ob-confirm__wrapper">
                        <div className="ob-confirm__half">
                            <div className="ob-confirm__half" dangerouslySetInnerHTML={{ __html: document.getElementById("FinalPageInformation").value }}></div>
                        </div>
                        <div className="ob-confirm__half">
                            <img src={document.getElementById('FinalPageInformationImage').value} alt="Truck" />
                        </div>
                    </div>
                </div>
                {(values.agentAddress) ?
                    <div className="ob-confirm__agent">
                        <div className="ob-confirm__wrapper">
                            <div className="ob-confirm__half">
                                <h2 className="ob-confirm__h2">Meet your local agent</h2>
                                {/* <h3 className="ob-confirm__h3" id="agentName">
                {values.agentName}
              </h3> */}
                                <p id="agentName">
                                    <span className="details-item--bold">
                                        Agent Name : {values.agentName}
                                    </span>
                                </p>
                                {/* <p className="ob-confirm__paragraph" id="agentDescription">
                Proin gravida dolor leo, et finibus mauris aliquam et. Interdum
                et malesuada fames ac ante ipsum primis in faucibus. Aliquam a
                varius neque. Dones in dictum turpis. Nunc ornare massa eget
                posuere commodo.
              </p> */}
                                <p id="agentPhone">
                                    <span className="details-item--bold">
                                        Agent Phone :&nbsp;
                                        <a className="ob-confirm__link" href="tel:234-456-7890">
                                            {values.agentPhone}
                                        </a>
                                    </span>
                                </p>
                                <p id="agentLocation">
                                    <span className="details-item--bold">
                                        Agent Address :&nbsp;
                                        <a className="ob-confirm__link" href="/">
                                            {values.agentAddress}
                                        </a>
                                    </span>
                                </p>
                            </div>
                            <div className="ob-confirm__half">
                                <Wrapper apiKey="AIzaSyAvVn5kBiODEp28sDah76-rS0D17D3FQEw">
                                    <MapComponent address={values.agentAddress} zoom={10} />
                                </Wrapper>
                            </div>
                        </div>
                    </div>
                    :
                    <></>
                }
            </>
        );
    }
}

function MapComponent({ address, zoom }) {
    const ref = useRef();

    useEffect(() => {
        Geocode.fromAddress(address).then(
            (response) => {
                const center = response.results[0].geometry.location;
                const map = new window.google.maps.Map(ref.current, {
                    center,
                    zoom,
                });

                const image = {
                    url: "/ResourcePackages/Allied/assets/dist/img/template/map-marker.png",
                    size: new window.google.maps.Size(79, 79),
                    origin: new window.google.maps.Point(0, 0),
                    anchor: new window.google.maps.Point(39, 39)
                };

                new window.google.maps.Marker({
                    position: center,
                    map: map,
                    icon: image
                });
            },
            (error) => {
                console.error(error);
            }
        );
    });

    return <div ref={ref} id="map" style={{ width: '100%', height: '100%' }} />;
}

export default Confirm;